import React, { ReactElement } from 'react';
import { ClipLoader } from 'react-spinners';

const LoadingSpinner = (): ReactElement => {
  return (
    <div
      className="d-flex justify-content-center align-items-center flex-fill py-5"
      role="status"
      aria-label="loading"
    >
      <ClipLoader size={64} />
    </div>
  );
};

export default LoadingSpinner;
